import { render, staticRenderFns } from "./tnb-log.vue?vue&type=template&id=27c2ffe6&scoped=true&"
import script from "./tnb-log.vue?vue&type=script&lang=js&"
export * from "./tnb-log.vue?vue&type=script&lang=js&"
import style0 from "./tnb-log.vue?vue&type=style&index=0&id=27c2ffe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2ffe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VBtn,VContainer,VIcon})
